// The build injects the client's version: package.json's, plus the git commit it was built from ("-dirty" with
// uncommitted changes). Shown on the login screen beside the protocol version.
declare const __ASHENHEART_CLIENT_VERSION__: string;

export const clientVersion = typeof __ASHENHEART_CLIENT_VERSION__ === 'undefined' ? 'dev' : __ASHENHEART_CLIENT_VERSION__; // tests/custom bundles
